import React, { useState } from 'react';
import classNames from 'classnames';
import ArticleList from '../ArticleList'; //TODO fixa mer generiskt
import * as Render from '../Base/Render';
import { useSweLang } from '../Helpers/helpers';
import { LazyLoadImage } from '../Image';
import Linklist from '../Linklist';
import Section from '../Section';
import ListViewToggler from './list-view-toggler';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const TeaserItemLinkList = (props) => {
  const href = useWindowLocationHref();
  const contentClassNames = classNames({
    'c-teaser__content': true,
    'c-teaser__content--with-img': props.Media,
  });

  const teaserContainsImage =
    props.Media &&
    props.Media[0] &&
    props.Media[0].ImageUrl &&
    props.Media[0].ImageUrl.length > 0;

  return (
    <li className="medium-6 large-3 columns">
      <div
        className={classNames({
          'c-teaser': true,
        })}
      >
        {props.Media && (
          <div className="c-teaser__img-container">
            {props.ShowVideoPlayIcon && teaserContainsImage && (
              <img
                src={'/ClientResources/Icons/play-button-small-white.svg'}
                alt={'Artikel innehåller video'}
                title={'Artikel innehåller video'}
                className="c-teaser-videoicon"
                tabIndex={'-1'}
              />
            )}

            <div className="c-teaser__img">
              <Render.Block
                blocks={props.Media}
                propertyName="TeaserMedia"
                currentPageProps={props}
              >
                <LazyLoadImage
                  isBackgroundImage={true}
                  DefaultPreset={{ name: 'preset_600' }}
                  Sizes={{
                    sizes:
                      '(min-width: 1025px) 300px, (min-width: 640px) calc(100vw / 3) , 100vw',
                  }}
                />
              </Render.Block>
            </div>
          </div>
        )}
        <div className={contentClassNames}>
          <h3
            data-event-category={href || 'novalue'}
            data-event-action={props.Title}
            data-event-value={props.Url}
            data-event-name="TeaserItemLinkList"
            className="c-teaser__heading"
            dir={props.Dir}
          >
            <a
              data-event-include
              className="c-teaser__heading__link"
              href={props.Url}
            >
              <span data-event-include>{props.Title}</span>
            </a>
          </h3>
          {props.TitleTranslation && (
            <span
              dir="ltr"
              className="c-teaser__translation"
              lang={useSweLang(props.Lang)}
            >
              {props.TitleTranslation}
            </span>
          )}
          <div className="c-teaser__text">
            {props.Preamble && <p>{props.Preamble}</p>}
            <Linklist Modifiers={{ 'teaser-linklist': true }} {...props} />
          </div>
        </div>
      </div>
    </li>
  );
};

const TeaserItemLink = (props) => {
  const href = useWindowLocationHref();
  const classes = props.className
    ? props.className
    : props.horizontalDirection
    ? 'columns c-teaser-outer'
    : 'medium-6 large-3 columns c-teaser-outer';

  const teaserHeadingLink = classNames({
    'c-teaser__heading--no-text': !props.Preamble,
  });

  const teaserClasses = classNames({
    'c-teaser': true,
    'c-teaser--eq-height': true,
    'c-teaser--has-img': props.Media,
  });

  const teaserContainsImage =
    props.Media &&
    props.Media[0] &&
    props.Media[0].ImageUrl &&
    props.Media[0].ImageUrl.length > 0;

  return (
    <li className={classes} data-cy="ui-teaser">
      <div className={teaserClasses} aria-label={props.Title}>
        <div
          className={classNames({
            'c-teaser__wrapper': true,
            'c-teaser__direction-row': props.horizontalDirection,
          })}
        >
          {props.Media && (
            <div className="c-teaser__img-container">
              {props.ShowVideoPlayIcon && teaserContainsImage && (
                <img
                  src={'/ClientResources/Icons/play-button-small-white.svg'}
                  alt={'Artikel innehåller video'}
                  title={'Artikel innehåller video'}
                  className="c-teaser-videoicon"
                  tabIndex={'-1'}
                />
              )}

              <Render.Block
                blocks={props.Media}
                propertyName="TeaserMedia"
                currentPageProps={props}
              >
                <LazyLoadImage
                  isBackgroundImage={true}
                  className="c-teaser__img"
                  DefaultPreset={{ name: 'preset_600' }}
                  Sizes={{
                    sizes:
                      '(min-width: 1025px) 300px, (min-width: 640px) calc(100vw / 3), 100vw',
                  }}
                />
              </Render.Block>
            </div>
          )}
          <div className="c-teaser__content">
            <h3
              data-event-category={href || 'novalue'}
              data-event-action={props.Title}
              data-event-value={props.Url}
              data-event-name="TeaserItemLink"
              className="c-teaser__heading"
              dir={props.Dir}
            >
              <a className={teaserHeadingLink} href={props.Url}>
                <span data-event-include className="c-teaser__heading__link">
                  <span data-event-include>{props.Title}</span>
                </span>
              </a>
            </h3>
            {props.TitleTranslation && (
              <span
                dir="ltr"
                className="c-teaser__translation"
                lang={useSweLang(props.Lang)}
              >
                {props.TitleTranslation}
              </span>
            )}
            {props.Preamble && (
              <div className="c-teaser__text">
                <p>{props.Preamble}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

const ListChildren = (props) => {
  if (!props.Items) return null;
  let masonryLayout = props.IsListOfChildren || props.masonryLayout;

  const listStyle = classNames({
    row: props.Items.length > 2,
    'u-flexwrap': !masonryLayout || !props.toggleBrickView,
    'u-columns': masonryLayout,
    'u-columns--gt-3': masonryLayout && props.Items.length > 3,
    'u-columns--gt-4': masonryLayout && props.Items.length > 4,
    'u-columns--is-listview': masonryLayout && !props.toggleBrickView,
    'u-flexwrap--is-listview': !props.toggleBrickView,
    'u-article--center': props.Items.length <= 2,
    ...props.WrapperModifiers,
  });

  const Items = props.Items.map((item, index) => {
    if (
      props.BlockTypeName === 'PageListBlock' ||
      props.Design === 'page-list'
    ) {
      return props.IsListOfChildren ? (
        <TeaserItemLinkList key={`teaser${index}`} {...item} />
      ) : (
        <TeaserItemLink key={`teaser${index}`} {...item} />
      );
    } else if (props.CurrentPageProps.BlockTypeName === 'DoubleColumnBlock') {
      return (
        <ArticleList
          key={`teaser${index}`}
          {...item}
          numOfItems={props.Items.length}
          blockName={props.CurrentPageProps.BlockTypeName}
        />
      );
    } else {
      return (
        <ArticleList
          key={`teaser${index}`}
          {...item}
          numOfItems={props.Items.length}
          pageName={props.CurrentPageProps.PageTypeName}
          use1177ProfessionDesign={
            props.CurrentPageProps?.FeatureToggleSettings
              ?.Use1177ProfessionDesign
          }
        />
      );
    }
  });

  let cypressValues = classNames({
    'ui-article-list': props.BlockTypeName === 'ManuelPageListBlock',
    'ui-search-article-list': props.BlockTypeName == 'SearchArticleListBlock',
  });
  if (cypressValues.length < 1) cypressValues = null;

  return props.BlockTypeName === 'PageListBlock' ? (
    <ul className={listStyle} data-cy={cypressValues}>
      {props.BlockTypeName === 'PageListBlock'
        ? Render.Property(Items, 'ListRoot')
        : Render.Property(Items, 'MainContent')}
    </ul>
  ) : (
    <div className={listStyle} data-cy={cypressValues}>
      {props.BlockTypeName === 'PageListBlock'
        ? Render.Property(Items, 'ListRoot')
        : Render.Property(Items, 'MainContent')}
    </div>
  );
};

const Teaser = (props) => {
  const modifiers = {
    ...props.SectionModifiers,
    'c-section--navigation': props.BlockTypeName === 'PageListBlock',
  };

  const [toggleBrickView, setToggleBrickView] = useState(!props.ShowListView);

  const showListViewToggler =
    props.BlockTypeName === 'PageListBlock' && props.UseListToggler;

  const sectionHeader = classNames({
    'c-section__header': true,
    'c-section__header--listview-shown': showListViewToggler,
    'c-section__header--heading-shown': props.Heading,
    'c-section__header--double-column':
      props.CurrentPageProps.BlockTypeName == 'DoubleColumnBlock',
  });

  return (
    <Section Modifiers={modifiers}>
      <div className="row">
        <div className="columns">
          <header className={sectionHeader}>
            {props.Heading ? (
              <h2 className="c-section__heading">
                <span>{props.Heading}</span>
              </h2>
            ) : (
              <h2 className="show-for-sr">
                {props.Translations?.currentarticles}
              </h2>
            )}
            {showListViewToggler && (
              <ListViewToggler
                Language={props.CurrentPageProps.Language}
                translations={props.Translations}
                onClick={(value) => {
                  setToggleBrickView(value);
                }}
                toggleBrickView={toggleBrickView}
              />
            )}
          </header>
        </div>
      </div>
      {props.Items && (
        <ListChildren {...props} toggleBrickView={toggleBrickView} />
      )}
      {props.children}
    </Section>
  );
};

export { Teaser, TeaserItemLink };
